import { PeopleTeamRegular, PersonInfoRegular } from '@fluentui/react-icons';
import type { ModuleDef } from '#src/app/navigation/module';

export const teamsModule: ModuleDef = {
  path: 'teams',
  title: 'Teams',
  icon: PeopleTeamRegular,
  placement: 'footer',
  pages: [
    {
      path: 'usuario',
      title: 'Usuário',
      description:
        'O que o Teams e o Entra ID dizem de você, sem pedir permissões novas.',
      icon: PersonInfoRegular,
      // Diagnóstico para quem administra: mostra ids do tenant e do app.
      permission: 'TeamsUser.Read',
      load: () =>
        import('#src/modules/teams/TeamsUserPage').then((m) => m.TeamsUserPage),
    },
  ],
};
